import * as Yup from "yup";
import moment from "moment";

export const VALIDATION_SCHEMA = Yup.object().shape({
  emails: Yup.array()
    .transform(function (value, originalValue) {
      if (this.isType(value) && value !== null) {
        return value;
      }
      return originalValue ? originalValue.split(/[\s,]+/) : [];
    })
    .of(Yup.string().email(({ value }) => `${value} is not a valid email`))
    .when("use_date_range", {
      is: false,
      then: (schema) => schema.required("Email is required"),
      otherwise: (schema) => schema.nullable(),
    }),
  is_period_report: Yup.boolean(),
  report_title_date: Yup.date()
    .typeError("Invalid report title date")
    .max(moment().endOf("day"), "Report title date can't be in the future")
    .when("use_date_range", {
      is: false,
      then: (schema) => schema.required("Report title date is required"),
      otherwise: (schema) => schema.nullable(),
    }),
});
